import React, { Component } from 'react'
import './ProjectPreview.css'

import { Link } from 'react-router-dom'

export default class ProjectPreview extends Component {

	render() {

		let { project, index } = this.props

		let projectPreview = 'projectPreview'

		if(index === 0)
			projectPreview += ' first'

		return (
			<Link 
			  to={`/projects/${project.id}`}
			  className={projectPreview}
			  style={{backgroundColor: project.backgroundColor }}
			  onClick={this.props.onClick}>
				<div className='previewHeader'>
					<h1>{project.name}</h1>
				</div>
				<div className='imgContainer'>
					<img src={require(`../assets/${project.img}`)} className={project.wideImg ? 'wideImg' : ''}/>
				</div>
				<div className='previewHeader'>
					<h2>{project.type}</h2>
					<h1>{project.service}</h1>
				</div>
			</Link>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/ProjectPreview.js